import React from "react";
import ReactDOM from "react-dom/client";
import { persistQueryClientRestore } from "@tanstack/query-persist-client-core";
import { registerSW } from "virtual:pwa-register";
import { App, persistOptions, queryClient } from "./app/App";
import "./index.css";
import { installTestSeam } from "./testing/seam";

// PWA app shell (spec §8.13); updates apply on next load
registerSW({ immediate: true });
installTestSeam();
// restore server-data cache before routing so the auth guard works offline (spec §16.1)
await persistQueryClientRestore({ queryClient, ...persistOptions }).catch(() => {});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
